import { E_RESET_ERROR, E_SET_ERROR } from '../../constants'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function setError(error: any) {
  return {
    type: E_SET_ERROR,
    payload: error?.message ?? 'unknown error'
  }
}

export function resetError() {
  return {
    type: E_RESET_ERROR
  }
}
